import React from "react";
import styles from "./centerButtons.module.css";

const CenterButtons = ({
  activeButton,
  setActiveButton,
  contentButtons,
  largeWidth,
}) => {
  return (
    <div className={styles.container}>
      {contentButtons.map((title, index) => (
        <button
          key={index}
          className={`${styles.button} ${
            activeButton === index ? styles.active : ""
          }`}
          onClick={() => setActiveButton(index)}
          style={{ width: largeWidth ? "10rem" : "" }}
        >
          {title}
        </button>
      ))}
    </div>
  );
};

export default CenterButtons;
